import React, { ReactNode } from 'react';
import { Skeleton } from 'antd';
import { SkeletonButtonProps as SkeletonButtonCopyProps } from 'antd/lib/skeleton/Button';

export type SkeletonButtonProps = SkeletonButtonCopyProps & {
  children?: ReactNode;
};

const ProSkeletonButton: React.FC<SkeletonButtonProps> = (props) => {
  const { children, ...resProps } = props;

  return <Skeleton.Button {...resProps}>{children}</Skeleton.Button>;
};

export default ProSkeletonButton;
